import { endPoints, requestType } from "../theme/Variables";
import Api from "./index";

export const fetchBanners = () => {
  return Api(endPoints.fetchBanners, null, requestType.GET);
};

export const createBanners = (params) => {
  return Api(endPoints.createBanners, params, requestType.POST);
};
export const updateBanners = (id, params) => {
  return Api(`${endPoints.updateBanners}/${id}`, params, requestType.PUT);
};
export const deleteBanners = (id) => {
  return Api(`${endPoints.deleteBanners}/${id}`, null, requestType.DELETE);
};
